import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ToiletDeclarationForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    applicantName: '',
    age: '',
    date: '',
    aadharNo: '',
    occupation: '',
    photo: null,
    fatherName: '',
    residence: '',
    district: '',
    taluka: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFormData(prev => ({ ...prev, photo: e.target.files[0] }));
  };

  const handlePrint = () => {
    window.print();
  };

  

  return (
    <div className="min-h-screen bg-[#f4f6f9] py-5 px-2 font-sans">
      <style>
        {`
          @media print {
            @page {
              size: A4;
              margin: 0;
            }
            body {
              background: white !important;
              margin: 15mm !important;
            }
            #printable-area {
              visibility: visible;
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              padding: 10mm;
              display: block !important;
              color: black !important;
            }
            .no-print {
              display: none !important;
            }
          }
        `}
      </style>

      {/* Main Form */}
      <div className="w-full bg-white border border-gray-300 shadow-sm rounded-sm overflow-x-auto no-print">
        <div className="bg-[#fff9e6] py-2 px-4 border-b border-gray-300 relative min-w-[300px]">
          <h2 className="text-[#b71c1c] text-[17px] font-bold flex items-center gap-2">
            <span className="text-blue-600 text-xl leading-none">✹</span> शौचालय स्वयं घोषणापत्र
          </h2>
          <button onClick={() => navigate(-1)} className="absolute top-2 right-4 bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-1 px-4 rounded text-sm no-print">
            मागे जा
          </button>
        </div>

        <div className="p-6 w-full">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-x-12 gap-y-6 mb-8">
            
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">अर्जदाराचे नाव</label>
              <input type="text" name="applicantName" placeholder="अर्जदाराचे नाव" value={formData.applicantName} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">वय</label>
              <input type="text" name="age" placeholder="वय" value={formData.age} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">दिनांक</label>
              <input type="date" name="date" value={formData.date} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
            </div>

            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">आधार क्रमांक (वैकल्पिक)</label>
              <input type="text" name="aadharNo" placeholder="आधार क्रमांक" value={formData.aadharNo} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">व्यवसाय:</label>
              <input type="text" name="occupation" placeholder="व्यवसाय" value={formData.occupation} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">फोटो</label>
              <input type="file" accept="image/*" onChange={handleFileChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
            </div>

            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">वडिलांचे नाव</label>
              <input type="text" name="fatherName" placeholder="वडिलांचे नाव" value={formData.fatherName} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
            </div>

            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">राहणार</label>
              <input type="text" name="residence" placeholder="राहणार" value={formData.residence} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
            </div>

            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">जिल्ह्याचे नाव</label>
              <select name="district" value={formData.district} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400 bg-white">
                <option value="">जिल्हा निवडा</option>
                <option value="सांगली">सांगली</option>
                <option value="सातारा">सातारा</option>
                <option value="कोल्हापूर">कोल्हापूर</option>
                <option value="पुणे">पुणे</option>
                <option value="सोलापूर">सोलापूर</option>
              </select>
            </div>

            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">तालुक्याचे नाव</label>
              <input type="text" name="taluka" placeholder="तालुक्याचे नाव" value={formData.taluka} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
            </div>
          </div>
          
          <div className="mt-10 flex flex-col md:flex-row gap-4 justify-center no-print">
            <button className="bg-[#00a65a] text-white px-8 md:px-20 w-full md:w-auto py-1.5 rounded-sm text-sm font-semibold shadow-sm hover:bg-[#008d4c]">Save</button>
            <button onClick={handlePrint} className="bg-[#f39c12] text-white px-8 md:px-20 w-full md:w-auto py-1.5 rounded-sm text-sm font-semibold shadow-sm hover:bg-[#e08e0b]">Print</button>
          </div>

                  </div>
      </div>

      <div id="printable-area" className="mt-8 border border-gray-300 rounded-sm bg-white p-4 font-serif text-black">
            <div className="text-center mb-2 border-b border-gray-300 pb-2">
          <p className="text-[12px]">संदर्भ: महाराष्ट्र शासन ग्रामविकास विभाग शासन क्रमांक आरटीएस-2018/प्र.क्र.145/आस्था.5 दिनांक: 13 फेब्रुवारी 2019</p>
        </div>

        <div className="text-center mb-8">
          <h1 className="text-[22px] font-bold underline text-center">शौचालय स्वयं-घोषणापत्र</h1>
        </div>

        <div className="flex justify-end mb-6">
          <div className="border-2 border-black w-32 h-40 flex items-center justify-center text-[10px] text-gray-400 text-center px-2">
            {formData.photo ? <img src={URL.createObjectURL(formData.photo)} alt="Applicant" className="w-full h-full object-cover" /> : "येथे फोटो चिकटवावा"}
          </div>
        </div>

        <div className="text-[16px] leading-[1.8] text-justify px-4">
          <p className="mb-6">
            मी <b>{formData.applicantName}</b> यांचा मुलगा/मुलगी वय <b>{formData.age}</b> वर्ष, आधार कार्ड क्र. (असल्यास) <b>{formData.aadharNo || '-----------'}</b> व्यवसाय- <b>{formData.occupation}</b> राहणार - <b>{formData.residence}</b> ता.<b>{formData.taluka}</b> जि. <b>{formData.district}</b> मी याद्वारे घोषित करतो/करते कि, माझ्या घरामध्ये शौचालयाची कायमस्वरूपी सोय उपलब्ध असून मी व माझे कुटुंब उघड्यावर शौचास जात नाही. आम्ही नियमितपणे शौचालयाचा वापर करतो.
          </p>

          <p>
            तसेच मी याद्वारे घोषित करतो/करते कि, वरील सर्व माहिती माझ्या व्यक्तिगत माहिती व समजुतीनुसार खरी आहे. सदर माहिती खोटी आढळून आल्यास भारतीय दंड संहिता अन्वये आणि/किंवा संबंधित कायद्यानुसार माझ्यावर खटला भरला जाईल व त्यानुसार मी शिक्षेस पात्र राहीन. तसेच सदर स्वयंघोषणापत्राद्वारे मला मिळालेले सर्व लाभ सर्वंकषरित्या काढून घेण्यात येतील याची मला पूर्ण जाणीव आहे.
          </p>
        </div>

        <div className="flex justify-between items-start mt-20 px-4">
          <div className="text-left space-y-2">
            <p className="font-bold">ठिकाण:- {formData.residence}</p>
            <p className="font-bold">दिनांक:- {formData.date}</p>
          </div>
          <div className="text-right space-y-2">
            <p className="font-bold">अर्जदाराची सही: --------------------</p>
            <p className="font-bold">अर्जदाराचे नाव: {formData.applicantName}</p>
                              </div>
        </div>
          </div>
    </div>
  );
};

export default ToiletDeclarationForm;
